import React from 'react'
import { Button as MaterialButton } from '@material-tailwind/react'

export interface ButtonBaseProps {
  children: React.ReactNode
  disabled?: boolean
  onClick?: () => void
  className?: string
  fullWidth?: boolean
  style?: React.CSSProperties
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  shape?: 'rectangle' | 'square' | 'circle'
  size?: 'small' | 'medium' | 'large'
  letter?: string
  ariaLabel?: string
  'data-testid'?: string
}

const ButtonBase: React.FC<ButtonBaseProps> = ({
  children,
  disabled = false,
  onClick,
  className = '',
  fullWidth = false,
  style,
  onMouseEnter,
  onMouseLeave,
  shape = 'rectangle',
  size = 'medium',
  letter,
  ariaLabel,
  'data-testid': dataTestId
}) => {
  // Get size classes
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'px-3 py-2 text-sm'
      case 'large':
        return 'px-6 py-4 text-lg'
      case 'medium':
      default:
        return 'px-4 py-3 text-sm'
    }
  }

  // Get shape classes
  const getShapeClasses = () => {
    switch (shape) {
      case 'square':
        return 'rounded-lg aspect-square'
      case 'circle':
        return 'rounded-full aspect-square'
      case 'rectangle':
      default:
        return 'rounded-lg'
    }
  }

  const sizeClasses = getSizeClasses()
  const shapeClasses = getShapeClasses()

  return (
    <MaterialButton
      disabled={disabled}
      onClick={onClick}
      className={`font-lexend ${sizeClasses} ${shapeClasses} ${className}`}
      style={{
        textTransform: 'none',
        fontWeight: 500,
        ...style
      }}
      fullWidth={fullWidth}
      size="md"
      variant="filled"
      color="white"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      placeholder={undefined}
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
      onResize={undefined}
      onResizeCapture={undefined}
    >
      {letter || children}
    </MaterialButton>
  )
}

export default ButtonBase
